import React, { useEffect, useState } from "react";
import "./NewsEvents.css";
import technopark from "../images/technopark.jpg";
import BASE_URL from "../apiConfig";

function NewsEvents() {

  const [newsData, setNewsData] = useState([]);
  const [selectedImg, setSelectedImg] = useState(null);

  useEffect(() => {
    fetch(BASE_URL + "/NewsApi/getNews")
      .then((res) => res.json())
      .then((data) => {
        // Show "News" tagged pictures first
        const sortedData = [...data].sort((a, b) => {
          const aTag = (a.tag || "").toLowerCase();
          const bTag = (b.tag || "").toLowerCase();
          if (aTag === "news" && bTag !== "news") return -1;
          if (aTag !== "news" && bTag === "news") return 1;
          return 0;
        });
        setNewsData(sortedData);
      })
      .catch((error) => {
        console.error("Error fetching news:", error);
      });
  }, []);

  const openImgModal = (imgUrl) => {
    setSelectedImg(imgUrl);
    document.body.style.overflow = "hidden"; // Prevent scrolling
  };

  const closeImgModal = () => {
    setSelectedImg(null);
    document.body.style.overflow = "auto";
  };

  return (
    <div className="news-page-wrapper">

      {/* HERO SECTION */}
      <div
        className="bg-container-news"
        style={{ backgroundImage: `url(${technopark})` }}
      ></div>

      <div className="news-hero-wrapper">
        <div className="news-hero-content">
          <h1>News & Events</h1>
          <h2>Stay informed with IGNOSI milestones.</h2>
          <p>
            Stay updated with our product launches, client milestones,
            industry events, media mentions and training programs
            as we reshape financial technology.
          </p>
        </div>
      </div>

      {/* NEWS GRID */}
      <section className="news-grid-container">
        <div className="news-grid">

          {newsData.map((item) => (
            <div className="news-card-premium" key={item.id}>

              <div
                className="news-card-image"
                onClick={() => openImgModal(item.image)}
                title="Click to view full image"
              >
                <img src={item.image} alt={item.title} />
                <span className="news-card-tag">
                  {item.tag}
                </span>
              </div>

              <div className="news-card-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>

            </div>
          ))}

        </div>
      </section>

      {/* IMAGE MODAL */}
      {selectedImg && (
        <div className="news-modal-overlay" onClick={closeImgModal}>
          <div className="news-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="news-modal-close" onClick={closeImgModal}>&times;</button>
            <img src={selectedImg} alt="News Full Preview" className="news-modal-img" />
          </div>
        </div>
      )}

    </div>
  );
}

export default NewsEvents;